import { FC } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Card, CardContent } from 'lib/components';
import { DefaultLayout, PreferencesForm } from '../../../components';

const PreferencesPage: FC = () => (
  <DefaultLayout backTo="/account" className="account-preferences">
    <Card className="md:bg-getting-started bg-auto-100 bg-no-repeat bg-right mb-[104px] md:mb-[88px] !overflow-visible relative">
      <CardContent className="max-w-xl lg:max-w-3xl xl:max-w-5xl relative">
        <h2>Personalize your box</h2>
        <PreferencesForm />
      </CardContent>

      <StaticImage
        className="!absolute !hidden md:!block right-[-6.5%] top-[50%] translate-y-[-50%] max-w-[320px]"
        src="../../../images/chicken-skewer-dish.png"
        alt="A delicious plate of carrots, cucumbers, jalapeños, and shrimp."
        placeholder="blurred"
      />
    </Card>
  </DefaultLayout>
);

export default PreferencesPage;
